type RoutingPathType = {
  [key: string]: string;
};

const RoutingPath: RoutingPathType = {
  ABOUT_US: 'https://partners.resortpass.com/about-us',
  BOOKING_SUCCESS: '/bookings/thankyou',
  BROWSE_DAY_ROOMS: '/browse-day-rooms',
  BROWSE_HOTELS: '/browse-hotels',
  BROWSE_POOLS: '/browse-pools',
  BROWSE_SPAS: '/browse-spas',
  CART_PAGE: '/products/checkout-confirmation',
  CHECKOUT_CONFIRMATION: '/products/checkout-confirmation',
  CHECKOUT_PAGE: '/users/guest-billing-detail',
  CHECKOUT_SURVEYS: '/checkout/surveys',
  CITIES: '/cities',
  DLP: '/hotels',
  GIFT_CARDS: '/giftcards',
  GIVE_20_GET_20: '/refer-navmenu',
  GUEST_BILLING_DETAILS: '/users/guest-billing-detail',
  GUEST_CHECKOUT: '/users/guest-checkout',
  HELP_PAGE: '/help',
  HOME_PAGE: '/',
  HOTEL_LISTING: 'https://partners.resortpass.com/',
  HOTEL_PRESS: 'https://partners.resortpass.com/press',
  HOTEL_SUPPORT: 'https://partners.resortpass.com/contact',
  MY_FAVORITES: '/users/my-favorites',

  // TODO: deprecate these
  RESULTS: '/[results]',
  SRP: '/hotel-day-passes',
};

export default RoutingPath;
